import script from "./FooterComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterComponent.vue?vue&type=script&setup=true&lang=js"

import "./FooterComponent.vue?vue&type=style&index=0&id=d64b8256&scoped=true&lang=css"

import exportComponent from "../../../web-sequence-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d64b8256"]])

export default __exports__